import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'

Vue.use(BootstrapVue)



// WEBPACK FOOTER //
// ./resources/js/plugins/bootstrap-vue.js